export function placeholderText(label) {
    const re = /^([\s\S]*?)\s*[(（]\s*([^)）]+?)\s*[)）]/;
    const m = label.match(re);
    if (!m) return '';
    const chinese = m[1].trim();
    const english = m[2].trim();
    return `请输入${chinese}/Input ${english}`;
}